import "./index.css";
import App from "./App";
import ReactDOM from "react-dom/client";
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import store, { persistor } from "state/store";
import { PersistGate } from "redux-persist/integration/react";
import ModalProvider from "context/ModalProvider";
import Modal from "components/Modal";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  /*<React.StrictMode>*/
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ModalProvider>
          <Router>
            <App />
            <Modal />
          </Router>
        </ModalProvider>
      </PersistGate>
    </Provider>
  /*</React.StrictMode>*/
);
